/**
 * Progressive-enhancement "load more" for archive pagination.
 *
 * Replaces FacetWP's AJAX pager. On real archives (category / taxonomy / author)
 * the trigger is a real <a href="/…/page/N/"> link (crawlable by Google); on the
 * home and 404 contexts it's a <button>. JS intercepts the click, fetches the
 * next page of rendered cards from the REST API, appends them, and dispatches a
 * `posts:appended` event (Masonry re-layout listens for it). On failure of a
 * real link, it falls back to a normal navigation.
 *
 * NOTE: transpiled by Bublé (buble-loader) which does NOT support async/await or
 * optional chaining — keep this file to promise chains and plain property access.
 */

var REST_URL = '/wp-json/magicrpm/v1/archive-posts';

function loadMore(trigger) {
  if (trigger.dataset.loading === '1') {
    return;
  }
  trigger.dataset.loading = '1';
  trigger.setAttribute('aria-busy', 'true');
  trigger.classList.add('is-loading');

  var paged = parseInt(trigger.dataset.next || '2', 10);
  var params = new URLSearchParams({
    context: trigger.dataset.context || 'recent',
    paged: String(paged),
  });

  var map = { cat: 'cat', taxonomy: 'taxonomy', termId: 'term_id', author: 'author' };
  Object.keys(map).forEach(function (dataKey) {
    if (trigger.dataset[dataKey]) {
      params.set(map[dataKey], trigger.dataset[dataKey]);
    }
  });

  function reset() {
    trigger.dataset.loading = '0';
    trigger.removeAttribute('aria-busy');
    trigger.classList.remove('is-loading');
  }

  fetch(REST_URL + '?' + params.toString(), {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  })
    .then(function (res) {
      if (!res.ok) {
        throw new Error('HTTP ' + res.status);
      }
      return res.json();
    })
    .then(function (data) {
      // The list is either an ancestor `.posts-list` (category/taxonomy/author)
      // or a sibling `#grid` in the same wrapper (home). Handle both.
      var scope = trigger.closest('.posts-list') || trigger.parentElement;
      var list = null;
      if (scope) {
        list = (scope.matches && scope.matches('#grid, .posts-list__list'))
          ? scope
          : scope.querySelector('#grid, .posts-list__list');
      }
      if (list && data.html) {
        list.insertAdjacentHTML('beforeend', data.html);
      }

      if (data.has_more) {
        trigger.dataset.next = String(paged + 1);
        if (trigger.tagName === 'A' && data.next_page_url) {
          trigger.setAttribute('href', data.next_page_url);
        }
      } else {
        trigger.classList.add('is-hidden');
        trigger.setAttribute('hidden', 'hidden');
      }

      document.dispatchEvent(new CustomEvent('posts:appended', { detail: { list: list } }));
      reset();
    })
    .catch(function () {
      reset();
      // Graceful fallback: follow the real paginated URL as a full page load.
      if (trigger.tagName === 'A' && trigger.getAttribute('href')) {
        window.location = trigger.getAttribute('href');
      }
    });
}

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.load-more');
  if (!trigger) {
    return;
  }
  event.preventDefault();
  loadMore(trigger);
});
